import React from 'react';
import '../../../src/html.scss'
import { useHistory } from 'react-router-dom';

const PricacyPolicy = () => {
    let history = useHistory()
    const goback = () => {
        history.goBack()
    }
    return (
        <div className="article">
            <h2 className='header'><span className='back' onClick={goback}>&lt;</span>la Politique de confidentialité</h2>
            <h2>Dreamehome Politique de confidentialité</h2>
            <p><strong>Introduction</strong></p>
            <p>L’application « Dreamehome » est exploitée par Dreame Innovation Technology (Suzhou) Co., Ltd. et ses sociétés
                affiliées (ci-après dénommées « Dreame » ou « Nous »). Elle est une plateforme qui vous fournit des services de
                contrôle et de gestion concernant vos dispositifs matériels intelligents.. Nous comprenons et apprécions
                l’importance de vos données personnelles et nous ferons de tous nos efforts pour les protéger. Nous prendrons
                les
                mesures de sécurité appropriées pour protéger vos données personnelles conformément aux normes de sécurité
                reconnues
                par l’industrie.</p>
            <p>Avant d'utiliser nos produits (ou services), veuillez lire attentivement et comprendre la politique de
                confidentialité de l'application Dreamehome.</p>
            <p>Si vous êtes mineur, vous devez avoir l'autorisation préalable de vos parents ou de votre tuteur légal pour
                utiliser cette application et leur demander de lire ces conditions.</p>
            <p>Nous avons pleinement tenu compte de vos besoins lors de la formulation de cette politique de confidentialité. Il
                est très important que vous compreniez parfaitement nos pratiques en matière de collecte et d'utilisation des
                données personnelles, ainsi que nos efforts pour vous permettre de gérer et de contrôler les données
                personnelles
                que vous nous fournissez. La présente politique de confidentialité couvre la manière dont nous collectons,
                utilisons, divulguons, traitons et conservons les informations que vous nous fournissez lorsque vous utilisez
                notre
                application. Nous nous conformerons strictement à cette politique de confidentialité lors de l'utilisation de
                vos
                informations.</p>
            <p>Cette politique de confidentialité vous aidera à comprendre :</p>
            <p>1. Quelles données nous recueillons et comment nous les utilisons.</p>
            <p>2. Comment nous utilisons les cookies et les technologies similaires</p>
            <p>3. Comment nous confions le traitement, partageons, transférons et divulguons publiquement vos données à
                caractère
                personnel</p>
            <p>4. Comment nous conservons et sécurisons vos données à caractère personnel</p>
            <p>5. Vos droits</p>
            <p>6. Comment nous gérons la transmission transfrontalière des données</p>
            <p>7. Nos informations de contact</p>
            <p>8. Comment nous mettons à jour la politique de confidentialité</p>
            <p>Annexe I : Détails du SDK tiers</p>
            <p>Notre objectif ultime est de vous offrir la meilleure expérience utilisateur. Nous avons des délégués à la
                protection des données (DPOs) basés dans différents pays et régions pour répondre à vos problèmes concernant la
                confidentialité des données. Si vous avez des questions sur la présente politique de confidentialité, vous
                pouvez
                contacter le DPO selon les informations de contact indiquées dans la section VII. Notre DPO répondra à votre
                demande
                dans le délai requis par les politiques et lois nationales pertinentes. Si vous n'êtes pas satisfait de notre
                réponse, en particulier si vous pensez que notre comportement en matière de traitement de vos données
                personnelles a
                porté atteinte à vos droits et intérêts légitimes, vous pouvez intenter une action en justice devant le tribunal
                populaire compétent, déposer une plainte auprès des organismes de réglementation gouvernementaux ou résoudre vos
                problèmes par d'autres approches externes.</p>
            <h3>I. Quelles sont les données que nous recueillons et comment nous les utilisons ?</h3>
            <p>Les données personnelles désignent toute information enregistrée électroniquement ou d'une autre manière qui peut
                être utilisée seule ou avec d'autres informations étant susceptible d’identifier une personne physique
                spécifique.
            </p>
            <p>Les données personnelles sensibles sont des informations qui, une fois divulguées, fournies illégalement ou
                utilisées de manière abusive, pourraient mettre en danger la sécurité des personnes et des biens, ou entraîner
                facilement des dommages à la réputation personnelle, à la santé mentale et physique, ou un traitement
                discriminatoire, etc. Les données personnelles sensibles comprennent, sans s'y limiter, les numéros
                d'identification, les informations biométriques personnelles, les données sur les comptes bancaires, les données
                sur
                les biens, les enregistrements des allées et venues, les données sur les transactions et les données
                personnelles
                des mineurs de moins de 14 ans (y compris), etc.</p>
            <p>Le but de la collecte de vos données à caractère personnel est de vous fournir des produits et/ou des services,
                et
                nous garantissons que nous les utiliserons conformément aux lois, règlements et autres documents normatifs
                applicables. Vous avez le droit de choisir de fournir ou non vos données. Mais dans la plupart des cas, si vous
                ne
                les fournissez pas, nous pourrions ne pas être en mesure de vous fournir les services correspondants et de
                répondre
                à vos demandes.</p>
            <h4>(I) Dreamehome collecte et traite vos données personnelles pour fournir des services fondamentaux</h4>
            <p>(1) Connexion et gestion des appareils</p>
            <p>Afin de fournir nos services pour que vous puissiez connecter et gérer vos appareils intelligents en toute
                sécurité, nous pouvons collecter vos données Wi-Fi, vos données de localisation, vos données de compte de
                connexion,
                vos données de téléphone mobile connexes, vos données d'appareil intelligent et celles associées de votre compte
                Dreame et de votre appareil intelligent. Ces données seront utilisées pour activer des fonctionnalités telles
                que la
                Connexion Rapide, la Connexion, la Recherche d'Appareils à Proximité et la Gestion d’Appareil. Plus précisément,
                les
                données que nous recueillons comprennent :</p>
            <p>Données sur le compte de connexion : le nom d'utilisateur, le mot de passe, le pseudonyme, la photo de profil,
                l'adresse électronique et le numéro de téléphone de votre compte Dreame. Dont votre nom d'utilisateur, votre mot
                de
                passe, votre numéro de téléphone et votre adresse électronique sont des données personnelles sensibles. Ces
                données
                sont collectées pour vérifier votre identité et vous aider à obtenir l'autorisation d'accéder au serveur avec
                votre
                compte d'application Dreamehome. Le nom d'utilisateur et le mot de passe que vous saisissez seront cryptés et
                transmis au serveur Dreame pour l'authentification de la connexion.</p>
            <p>Données relatives au téléphone mobile : identification de l'appareil (IMEI/OAID, adresse Mac et Android ID),
                modèle
                de téléphone, version du système, pays ou région, taille et résolution de l'écran, CPU et informations relatives
                au
                dispositif d'affichage. Ces données servent à vous permettre de connecter l'application Dreamehome à vos
                appareils
                intelligents.</p>
            <p>Informations sur les appareils intelligents : nom de l'appareil, modèle, version, fabricant, identifiant, adresse
                MAC, adresse IP, état de fonctionnement, attributs personnalisés, paramètres de réglage, événements commerciaux,
                contrôle de l'appareil et enregistrements d'utilisation. Ces informations servent à connecter votre appareil
                intelligent afin que vous puissiez contrôler et gérer l'appareil, définir les paramètres de l'appareil, et
                visualiser l'état de fonctionnement et les historiques de votre appareil.</p>
            <p>(2) Mise à jour de votre application Dreamehome et de votre appareil intelligent</p>
            <p>Afin de garantir que vous puissiez profiter en permanence de nos derniers services, nous pouvons utiliser les
                données sur la version de votre application Dreamehome et le modèle de votre téléphone pour fournir des services
                mis
                à jour. En outre, nous pouvons également collecter la liste et les informations de version de votre appareil
                connecté pour que vous puissiez utiliser la dernière version de nos services (y compris la version du
                micrologiciel). Dreamehome fournit uniquement des services mis à jour sur vos appareils intelligents. Le
                fabricant
                de l'appareil fournit le micrologiciel correspondant et est responsable de la qualité du micrologiciel et des
                résultats de la mise à jour.</p>
            <p>Si vous choisissez de ne pas fournir ces données, vous risquez de ne pas en mesure de mettre à jour Dreamehome et
                votre appareil intelligent.</p>
            <p>(3) Posez des problèmes ou des retours en lignes</p>
            <p>Afin de vous aider à résoudre efficacement les éventuels problèmes de l'application Dreamehome et de votre
                appareil
                intelligent, nous proposons un service en ligne sur les problèmes, qui nécessite vos informations personnelles,
                notamment : les journaux de l'application Dreamehome et de votre appareil intelligent, vos coordonnées, la
                description des problèmes, ainsi que des photos et des vidéos pertinentes. Les journaux de l'app et de
                l'appareil
                comprennent l'état de l'appareil, les informations détectées par les capteurs, les enregistrements de
                fonctionnement
                de l'appareil, les identifiants de l'appareil, etc. Ces informations sont collectées pour analyser et identifier
                les
                causes du problème. La collecte de vos informations de contact a pour but d'assurer le suivi de nos services et
                de
                mieux vous aider à résoudre le problème.</p>
            <p>Vos données personnelles ne seront utilisées que pour analyser et résoudre les problèmes et ne seront pas
                divulguées publiquement ou utilisées à des fins commerciales. Si vous ne fournissez pas ces informations, nous
                ne
                serons pas en mesure d'identifier et de résoudre efficacement vos problèmes.</p>
            <h4>(II) Dreamehome collecte et traite vos données à caractère personnel pour fournir des fonctions supplémentaires
            </h4>
            <p>En plus de fournir les services fondamentaux de l'application Dreamehome, nous pouvons également avoir besoin de
                collecter et d'utiliser vos données personnelles pour certaines fonctions supplémentaires. Si vous ne les
                fournissez
                pas, vous pouvez toujours utiliser les services fondamentaux de Dreamehome, mais vous risquez de ne pas utiliser
                les
                fonctions supplémentaires qui vous apporteront plus de confort. En plus des services fondamentaux, Dreamehome
                offre
                également :</p>
            <p>Programme d'Amélioration de l'Expérience Utilisateur :</p>
            <p>Afin d'améliorer votre expérience utilisateur, nous devons collecter les journaux de l'application Dreamehome, y
                compris les journaux de processus de clés cryptées, les journaux d'événements, les journaux d'erreurs, les
                événements commerciaux, l'utilisation de chaque interface, etc. Vos données personnelles sensibles ne seront pas
                enregistrées dans les journaux.</p>
            <p>Vos données personnelles seront utilisées de la manière suivante: les données ci-dessus seront automatiquement
                collectées et téléchargées sur le serveur; les informations du journal seront analysées pour diagnostiquer
                l'état de
                fonctionnement et analyser l'utilisation de l'application.</p>
            <p>Si vous ne fournissez pas ces informations, Dreamehome ne sera pas en mesure d'améliorer votre expérience
                d'utilisateur, mais vous pouvez toujours utiliser les services fondamentaux de Dreamehome.</p>
            <h4> (III)Nous pouvons collecter vos données à caractère personnel auprès de tiers</h4>
            <p>Dans certains cas, nous pouvons légalement acquérir vos données personnelles auprès d'un tiers. </p>
            <p>Avec votre autorisation, nous coopérerons avec des prestataires de services tiers pour la gestion de vos
                appareils
                intelligents, processus au cours duquel nous collecterons vos données personnelles auprès de prestataires de
                services tiers. Si vous gérez votre appareil intelligent avec un compte tiers, nous obtiendrons vos données
                personnelles lorsque votre application y sera liée. Les données suivantes seront collectées :</p>
            <p>Informations de votre compte tiers, y compris votre pseudo et votre photo de profil, qui seront affichées dans
                Dreamehome;</p>
            <p>Informations sur l'appareil et le réseau, y compris l'identifiant de l'appareil, l'adresse MAC et le numéro de
                série de l'appareil pour reconnaître l'appareil actuel et permettre le contrôle de sécurité.</p>
            <p>Si le traitement de vos données personnelles dans le cadre d'activités commerciales dépasse la portée de votre
                autorisation et de votre consentement initial lorsque vous fournissez les données à un prestataire de services
                tiers, nous obtiendrons votre consentement clair avant de les traiter. En outre, nous respecterons strictement
                les
                lois et règlements en vigueur et exigerons des fournisseurs de services tiers concernés qu'ils garantissent la
                légalité des données qu'ils fournissent.</p>
            <h4>(IV) Données non personnelles</h4>
            <p>Nous pouvons également collecter d'autres données qui ne servent pas à identifier un individu spécifique
                (c'est-à-dire des données qui ne sont pas personnellement identifiables), telles que des données statistiques
                générées lorsque vous utilisez un service spécifique, comme les comportements des utilisateurs (y compris les
                clics,
                les sauts de page et le temps de navigation), dans le but d’améliorer nos services. Les types et les quantités
                de
                données recueillies dépendent de la manière dont vous utilisez nos produits et/ou services. Nous recueillons ces
                données pour nous aider à fournir des informations plus conviviales et à mieux comprendre les préférences des
                clients pour notre site web, nos produits et nos services, afin d'optimiser nos services. Dans la présente
                politique
                de confidentialité, les données recueillies sont considérées comme celles non personnelles. Lorsque nous
                combinons
                des données non personnelles avec celles personnelles en cours d'utilisation, les données non personnelles
                feront
                partie des données personnelles.</p>
            <h3>II. Comment nous utilisons les cookies et les technologies similaires</h3>
            <p>Pour assurer le fonctionnement normal de Dreamehome, un petit fichier de données nommé Cookie est stocké sur
                votre
                appareil. Le Cookie comprend normalement des identifiants, des noms de sites et quelques chiffres et caractères.
                Avec l'aide du Cookie, Dreamehome peut enregistrer votre compte de connexion au site web, vos préférences et
                d'autres données.</p>
            <p>Nous n'utiliserons pas les cookies à d'autres fins que celles indiquées dans la présente politique de
                confidentialité. Vous pouvez gérer ou supprimer les cookies en fonction de vos préférences. Mais dans ce cas,
                votre
                accès sécurisé à l'application Dreamehome peut être affecté, et vous devrez peut-être modifier les paramètres de
                l'utilisateur chaque fois que vous accédez à l'application Dreamehome.</p>
            <h3>III. Comment nous confions le traitement, partageons, transférons et divulguons publiquement vos données
                personnelles</h3>
            <h4>(I) Traitement confié</h4>
            <p>Dans certaines circonstances, Dreame peut confier à d'autres sociétés le traitement de vos données personnelles,
                par exemple pour vous contacter, vous envoyer des courriers électroniques ou fournir une assistance technique en
                notre nom. Ces sociétés ne peuvent utiliser vos données personnelles que pour vous fournir des services en notre
                nom.</p>
            <p>Nous signerons un accord de confidentialité strict ou un accord de traitement des données personnelles avec la
                partie chargée, et nous exigerons qu'elle traite les données à caractère personnel conformément à la présente
                politique de confidentialité et qu'elle adopte des mesures de confidentialité et de sécurité pertinentes.</p>
            <h4>(II) Partage</h4>
            <p>Dans des circonstances générales, Dream ne partagera pas vos données personnelles avec d'autres sociétés,
                organisations ou individus, sauf dans les cas suivants :</p>
            <p>1.Avec votre consentement, nous partagerons les données dans le cadre de votre autorisation avec un tiers, ce qui
                inclut les informations et la configuration de vos produits de maison intelligents de vos parents et amis
                partageant
                les produits pour les aider à obtenir un accès rapide aux logiciels et services sur leurs appareils terminaux.
            </p>
            <p>2. Certains services de Dreamehome, tels que l'hébergement du site Web, l'analyse des données, le traitement des
                paiements et des cartes de crédit, la fourniture d'infrastructures, les services informatiques, les services
                d'assistance à la clientèle, les services d'envoi d'e-mails et d'autres services similaires, sont fournis par
                des
                prestataires de services tiers. Pour cette raison, nous devons fournir certaines de vos informations
                personnelles
                aux prestataires de services tiers.</p>
            <p>3. Nous pouvons communiquer vos données personnelles à des clients et autres partenaires commerciaux qui
                fournissent directement ou indirectement des dispositifs intelligents et/ou un réseau et des systèmes vous
                permettant d'accéder et d'utiliser notre site web et nos services.</p>
            <p>4. Si Dreame est impliquée dans une réorganisation, une fusion, une vente d'actifs, une coentreprise, une
                abaliénation, un transfert ou d'autres circonstances où tout ou partie de nos activités, actifs ou stocks
                doivent
                être cédés (y compris, mais sans s'y limiter, toute faillite ou procédure similaire liée aux circonstances
                ci-dessus), nous pouvons divulguer vos informations personnelles à des sociétés affiliées ou à d'autres tiers.
                Vous
                recevrez préalablement une notification claire par e-mail et/ou sur notre site web concernant le changement de
                propriétaire, l'incompatibilité de la nouvelle utilisation des informations personnelles et l'autorisation de
                vos
                données personnelles.</p>
            <p>5. Si nous croyons de bonne foi que l'accès, l'utilisation, la conservation ou la divulgation des données est
                raisonnablement nécessaire pour : (a) nous conformer aux lois et règlements applicables ; (b) nous conformer aux
                procédures légales ; (c) répondre aux exigences des institutions publiques et des autorités gouvernementales, y
                compris celles situées en dehors du pays/de la région où vous vivez ; (d) respecter nos conditions générales ;
                (e)
                protéger nos opérations, nos activités et nos systèmes ; (f) protéger nos droits, notre vie privée, notre
                sécurité
                ou nos biens et/ou ceux d'autres utilisateurs, y compris les vôtres ; et (g) chercher les recours disponibles ou
                limiter les compensations de dommages que nous pourrions avoir à fournir.</p>
            <p>6. Nous pouvons être amenés à divulguer vos renseignements personnelles à nos succursales ou à nos sociétés
                affiliées pour mener à bien des activités commerciales sur une base régulière.</p>
            <p>7. Nous partagerons les données nécessaires avec des tiers par le biais d'interfaces de programmation
                d'applications (APIs) et de kits de développement d'outils logiciels (SDKs). Les SDK de tiers varient selon les
                versions, et comprennent généralement des types de connexion de compte de tiers, des types de partage et des
                types
                de paiement de compte de tiers, des types de notifications de fabricant, des types de statistiques, etc. Nous
                effectuerons des inspections de sécurité strictes sur les tiers et conviendrons de mesures de protection des
                données. Dans l'Annexe 1, nous avons listé les détails des SDK tiers auxquels nous avons autorisé l'accès,
                veuillez
                le lire attentivement. Notre politique de confidentialité ne s'applique pas aux produits ou services fournis par
                des
                tiers. Vos informations personnelles peuvent être collectées lorsque vous utilisez ces produits ou services. Par
                conséquent, nous vous recommandons vivement de prendre le temps de lire la politique de confidentialité de ces
                tiers, tout comme vous lisez la nôtre. Nous n'avons aucune responsabilité ni aucun contrôle sur la manière dont
                les
                tiers utilisent les informations qu'ils recueillent auprès de vous. Notre politique de confidentialité ne
                s'applique
                pas aux autres sites web liés par nos services. Vous devez être responsable de la sécurité de vos informations
                personnelles lorsque vous interagissez avec les sites web liés. Avant que vous n'entriez sur la page d'un tiers
                pour
                la première fois, le fournisseur de services tiers vous montrera les accords et les déclarations de
                confidentialité
                pertinents. Veuillez lire attentivement ces déclarations.</p>
            <h4>(III) Transfert</h4>
            <p>Dreame ne transférera pas vos renseignements personnels à des sociétés, organisations ou individus, sauf dans les
                cas suivants :</p>
            <p>1.avec votre consentement explicite : nous ne transférerons vos informations personnelles à d'autres parties
                qu'après avoir obtenu votre consentement explicite ;</p>
            <p>2. Si Dreame est impliqué dans une fusion, une acquisition ou une liquidation judiciaire qui nécessite le
                transfert
                d'informations personnelles, nous exigerons que la nouvelle société ou organisation détenant vos données
                personnelles continue d'être liée par la présente politique de confidentialité, sinon nous demanderons à la
                société
                ou à l'organisation d'obtenir à nouveau votre autorisation.</p>
            <h4>(IV) Divulgation publique</h4>
            <p>Nous ne divulguons pas publiquement vos données personnelles sauf dans les cas suivants :</p>
            <p>1. avec votre consentement explicite ;</p>
            <p>2. lorsque nous avons une base légale : nous pouvons divulguer publiquement vos données personnelles conformément
                à
                la loi ou sur la base de procédures légales, de litiges ou d'exigences obligatoires des autorités
                gouvernementales.
            </p>
            <h3>IV. Comment nous conservons et sécurisons vos données personnelles</h3>
            <p>Nous conservons les données à caractère personnel pendant la période nécessaire à l'objectif de collecte de
                données
                décrit dans la présente politique de confidentialité, ou nous nous conformons aux exigences légales applicables.
                Nous cessons de les conserver et les supprimons ou les rendons anonymes une fois que nous avons atteint
                l'objectif
                de la collecte, ou après avoir confirmé votre demande de suppression ou d'annulation, ou après avoir mis fin à
                l'exploitation des produits ou services correspondants. Si c'est pour des raisons d'intérêt public, de recherche
                scientifique, historique ou statistique, nous continuerons à conserver les données pertinentes sur la base des
                lois
                applicables, même si le traitement ultérieur des données n'a rien à voir avec l'objectif initial de la collecte.
            </p>
            <p>Dans le cadre de l'activité de Dreamehome, la durée de conservation spécifique de vos données personnelles est la
                suivante :</p>
            <p>Pour les données stockées localement dans Dreamehome, lorsque vous désinstallez l'app ou effacez les données de
                l'app, toutes les données stockées seront supprimées immédiatement.</p>
            <p>Pour le dispositif intelligent et les données commerciales stockées sur le serveur, lorsque vous supprimez le
                dispositif intelligent, refusez d'accepter la politique de confidentialité de Dreamehome et cessez d'utiliser
                les
                services de Dreamehome, toutes les données stockées seront immédiatement supprimées.</p>
            <p>Pour les journaux d'activité, les données statistiques et les enregistrements historiques stockés sur le serveur,
                nous les supprimons lorsque nous nettoyons les données du serveur de temps en temps. Normalement, les données ne
                sont pas conservées plus de 2 ans.</p>
            <p>En outre, dans le cas où Dreame arrête l'exploitation des produits ou services correspondants, nous vous en
                informerons par le biais de notifications push, d'annonces, etc. et supprimerons vos données personnelles ou les
                rendront anonymes dans un délai raisonnable.</p>
            <h3>V. Vos droits</h3>
            <h4>(I) Accès, rectification et suppression</h4>
            <p>Conformément aux lois et règlements locaux applicables, vous avez le droit de demander à accéder, à rectifier ou
                à
                supprimer toute donnée que nous recueillons auprès de vous (ci-après dénommée la " demande "). Veuillez nous
                écrire
                ou nous contacter en visitant le site Dreamehome. Selon la plupart des lois, la demande d'une personne concernée
                par
                des données personnelles doit répondre à des exigences spécifiques. </p>
            <p>Dans la présente politique de confidentialité, les exigences relatives aux personnes concernées sont les
                suivantes
                :</p>
            <p>La demande doit être faite par le biais de nos canaux de demande dédiés. Pour garantir la sécurité de vos
                informations personnelles, la demande doit être formulée par écrit (sauf si la loi locale reconnaît clairement
                une
                demande verbale) ;</p>
            <p>Vous devez fournir suffisamment d'informations pour que nous puissions vérifier votre identité et nous assurer
                que
                la demande est faite par l'utilisateur lui-même ou par une personne légalement autorisée par l'utilisateur ;</p>
            <p>Une fois que nous avons acquis suffisamment d'informations pour confirmer que nous pouvons traiter votre demande,
                nous vous répondrons dans le délai spécifié par les lois applicables en matière de protection des données. Plus
                précisément, nos réponses comprennent :</p>
            <p>En fonction de votre demande et des lois et règlements applicables, nous pouvons vous fournir gratuitement une
                copie de vos données que nous avons collectées et traitées. Pour les autres demandes d'informations pertinentes,
                nous pouvons facturer des frais raisonnables basés sur nos coûts de gestion réels, conformément aux lois
                applicables.</p>
            <p>Si vous pensez que l'une des informations que nous détenons à votre sujet est incorrecte ou incomplète, vous
                pouvez
                demander à la rectifier ou à la compléter en fonction de la finalité de son utilisation.</p>
            <p>Conformément aux lois et règlements applicables, vous avez le droit de demander la suppression de vos données
                personnelles. Votre demande sera évaluée. Si elle est conforme aux lois et réglementations correspondantes, nous
                supprimerons vos données selon des procédures appropriées qui impliquent des mesures technologiques. Après la
                suppression des données pertinentes par vous ou par nous avec votre consentement, il se peut que nous ne soyons
                pas
                en mesure de les supprimer immédiatement du système de sauvegarde en raison des lois et des technologies de
                sécurité
                applicables. Dans ce cas, nous sécuriserons vos données personnelles et les isolerons de tout traitement
                ultérieur
                jusqu'à ce qu'elles puissent être effacées ou anonymisées. Par exemple, conformément à la loi sur le commerce
                électronique de la République populaire de Chine, les informations relatives à vos produits et services et
                celles
                relatives à vos transactions doivent être conservées pendant au moins trois ans à compter de la date
                d'achèvement de
                la transaction.</p>
            <p>Nous avons le droit de refuser de traiter une demande dans les cas suivants : la demande est déraisonnable ou
                contestée ; elle peut porter atteinte à la vie privée d'autrui ; elle est extrêmement irréaliste ; elle exige un
                travail technique disproportionné ; elle peut être ignorée selon les lois locales ; les informations ont été
                divulguées publiquement ; les informations ont été divulguées dans des conditions de confidentialité. Si nous
                estimons que, dans certains cas, la demande de suppression ou d'accès aux données peut nous empêcher d'utiliser
                légalement les données aux fins de lutte contre la fraude et de sécurité susmentionnées, nous pouvons également
                la
                rejeter.</p>
            <h4>(II) Retrait du consentement</h4>
            <p>Vous pouvez retirer votre consentement à la collecte, l’utilisation et / ou le partage de vos données
                personnelles
                en notre possession ou sous notre contrôle en soumettant une demande. En fonction du service spécifique que vous
                utilisez, vous pouvez le faire en nous contactant aux coordonnées indiquées à la section 7 du présent avis de
                confidentialité. Nous répondrons à votre demande dans un délai raisonnable et ne collecterons, n’utiliserons
                et/ou
                ne partageons plus vos données personnelles depuis lors. </p>
            <p>Veuillez noter qu'en fonction de la portée dans laquelle vous nous autorisez à traiter vos données, suite à votre
                retrait de consentement, il se peut que vous ne puissiez pas accéder aux services de l'app Dreamehome ou de ses
                appareils intelligents connectés. Toutefois, votre décision de révoquer votre consentement ou votre autorisation
                n'affectera pas le traitement antérieur des informations personnelles basé sur votre autorisation.</p>
            <p>Vous pouvez également vous retirer du programme d'amélioration de l'expérience utilisateur en demandant le
                retrait
                de votre consentement ou en visitant l'application Dreamehome.</p>
            <h4>(III) Annulation de votre compte Dreamehome</h4>
            <p>Vous pouvez annuler votre compte Dreamehome en allant dans « Moi » - « Paramètres du compte » - « Annuler le
                compte
                ». Mais veuillez le faire avec prudence et après bien réfléchi, car vous risquez de ne plus utiliser Dreamehome
                et
                ses produits et services du dispositif intelligent associé. Afin de garantir vos droits légaux ou ceux d’autrui,
                nous déterminerons s’il convient d’approuver votre demande d’annulation dans le cadre de votre utilisation des
                différents produits et services de matériel intelligent de Dreamehome.</p>
            <h3>VI. Comment nous gérons la transmission transfrontalière des données</h3>
            <p>Dreame s'appuie sur ses ressources et ses serveurs dans le monde entier pour vous fournir des produits et/ou des
                services. Par conséquent, avec votre consentement préalable, vos données personnelles peuvent être transférées
                vers
                d'autres juridictions en dehors du pays/de la région où vous utilisez les produits ou services, ou peuvent être
                accessibles par ces juridictions. Les politiques de protection des données et les lois pertinentes dans le
                pays/la
                région destinataire peuvent ne pas être aussi complètes que celles de votre pays/région actuel. Dans de telles
                circonstances, nous prendrons les mesures appropriées et légales conformément aux lois applicables de la
                juridiction
                correspondante pour garantir que vos données personnelles continuent d'être protégées.</p>
            <p>Note :</p>
            <p>Si vous êtes un résident de l'Espace économique européen (EEA) et que vos données personnelles sont transférées
                en
                dehors de l'EEA, nous traiterons vos données personnelles dans la zone où la Commission européenne peut fournir
                un
                niveau de protection suffisant ; ou mettrons en œuvre des mesures de protection appropriées pour sauvegarder vos
                renseignements personnels, notamment en transférant vos données conformément aux réglementations applicables en
                la
                matière, telles que les Clauses contractuelles standards (SCC) de la Commission européenne.</p>
            <h3>VII. Nos informations de contact</h3>
            <p>Si vous avez des retours ou des questions sur la présente politique de confidentialité, ou sur notre collecte,
                notre utilisation ou notre divulgation de vos données personnelles, veuillez nous contacter via les informations
                de
                contact ci-dessous ou en vous rendant sur le site Dreamehome et en intitulant le message par "Politique de
                confidentialité". Notre équipe de professionnels répondra à vos questions et à vos problèmes. Si votre question
                concerne des sujets assez importants, nous pourrons vous demander de fournir plus d'informations. Si vous n'êtes
                pas
                satisfait de notre réponse, vous pouvez déposer une plainte auprès de l'autorité de surveillance compétente dans
                votre juridiction. Si vous nous consultez au sujet des voies de recours, nous vous proposerons des options
                applicables en fonction de votre situation réelle.</p>
            <p><strong>E-mail:</strong></p>
            <p>Contact en Chine: <a className="page"
                href="mailto:privacy@dreame.tech">privacy@dreame.tech</a> </p>
            <p>Contact du DPD de Singapou : <a className="page"
                href="mailto:dpo.sg@dreame.tech">dpo.sg@dreame.tech</a> </p>
            <p>Contact du représentant de l’UE: <a className="page"
                href="mailto:representative.dreame@herrero.es">representative.dreame@herrero.es</a> </p>
            <p><strong>Numéro de contact:</strong> 400-875-9511</p>
            <p><strong>Site web:</strong> <a className="page"
                href="https://www.dreametech.com/ ">https://www.dreametech.com/ </a></p>
            <h3>VIII. Comment nous mettons à jour les conditions</h3>
            <p>Dreame se réserve le droit de mettre à jour la présente politique de confidentialité en temps utile. En cas de
                rectification, nous vous en informerons par le biais d'un message pop-up ou d'un autre moyen bien visible. Ce
                n'est
                qu'avec votre consentement que nous collecterons, utiliserons et conserverons vos données personnelles
                conformément
                à la politique mise à jour.</p>
            <p>Cette politique prend effet à compter de la date de mise à jour.</p>
            <p>Date de la dernière mise à jour : 28/08/2021</p>
            <p><strong>Annexe I : Détails du SDK tiers</strong></p>
            <p>L'application Dreamehome utilise une série de SDK tiers pour vous fournir des fonctionnalités et des services de
                base et supplémentaires plus professionnels et plus sûrs. Vous trouverez ci-dessous plus de détails sur les SDK
                tiers utilisés dans l'application Dreamehome :</p>
            <div className='tableStyle'>
                <table>
                    <tr>
                        <td>
                            <p>SDKs</p>
                        </td>
                        <td>
                            <p>Caractéritiques</p>
                        </td>
                        <td>
                            <p>Données recueillies</p>
                        </td>
                        <td>
                            <p>Politique de confidentialité des Tiers</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>SDK d'analyse statistique Umeng</p>
                        </td>
                        <td>
                            <p>Analyse statistique</p>
                        </td>
                        <td>
                            <p>Identifiant de l’appareil (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, IMSI INFO sur la Carte SIM),
                                géolocalisation</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>SDK de messagerie push Umeng</p>
                        </td>
                        <td>
                            <p>Notification push</p>
                        </td>
                        <td>
                            <p>Identifiant de l’appareil (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, IMSI INFO sur la Carte SIM),
                                géolocalisation</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Umeng U-share SDK</p>
                        </td>
                        <td>
                            <p>Partage avec des tiers</p>
                        </td>
                        <td>
                            <p>Identifiant de l’appareil (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, IMSI INFO sur la Carte SIM),
                                géolocalisation</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Agora SDK</p>
                        </td>
                        <td>
                            <p>Permettre le chat vocal et le streaming vidéo</p>
                        </td>
                        <td>
                            <p>Informations sur l’appareil, état de la connextion, caméra, microphone, stockage en lecture et en
                                écriture.
                            </p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.agora.io/cn/privacy-policy/">https://www.agora.io/cn/privacy-policy/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Huawei data-push SDK</p>
                        </td>
                        <td>
                            <p>Data-push</p>
                        </td>
                        <td>
                            <p>Identifiant de l'appareil</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169">https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Xiaomi data-push SDK</p>
                        </td>
                        <td>
                            <p>Data-push</p>
                        </td>
                        <td>
                            <p>Identifiant de l'appareil, modèle de l'appareil, type de réseau, stockage de l'appareil, informations
                                sur le
                                processus d'exécution de l'appareil, version de l'application, version du SDK.</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>OPPO data-push SDK</p>
                        </td>
                        <td>
                            <p>Data-push</p>
                        </td>
                        <td>
                            <p>Identifiant de l'appareil</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.oppomobile.com/wiki/doc#id=10194">https://open.oppomobile.com/wiki/doc#id=10194</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>VIVO data-push SDK</p>
                        </td>
                        <td>
                            <p>Data-push</p>
                        </td>
                        <td>
                            <p>Identifiant de l'appareil</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.vivo.com.cn/documentCenter/doc/366">https://dev.vivo.com.cn/documentCenter/doc/366</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>WeChat SDK</p>
                        </td>
                        <td>
                            <p>Connexion à WeChat, Partager sur WeChat </p>
                        </td>
                        <td>
                            <p>Identifiant de l'appareil, information sur le réseau</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>QQ SDK</p>
                        </td>
                        <td>
                            <p>Partager sur QQ</p>
                        </td>
                        <td>
                            <p>Identifiant de l'appareil, information sur le réseau</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Weibo SDK</p>
                        </td>
                        <td>
                            <p>Connexion à Weibo, Partager sur Weibo </p>
                        </td>
                        <td>
                            <p>Identifiant de l'appareil, information sur le réseau</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE">https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Apple ID SDK</p>
                        </td>
                        <td>
                            <p>Connextion avec Apple ID </p>
                        </td>
                        <td>
                            <p>Apple ID</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.apple.com/legal/privacy/szh/">https://www.apple.com/legal/privacy/szh/</a></p>
                        </td>
                    </tr>
                </table>
            </div>
            <div className='height'></div>
        </div>
    )
}

export default PricacyPolicy